import { render } from "./DatabaseCheck.vue?vue&type=template&id=4531effe"
import script from "./DatabaseCheck.vue?vue&type=script&lang=js"
export * from "./DatabaseCheck.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/DatabaseCheck.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4531effe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4531effe', __exports__)) {
    api.reload('4531effe', __exports__)
  }
  
  module.hot.accept("./DatabaseCheck.vue?vue&type=template&id=4531effe", () => {
    api.rerender('4531effe', render)
  })

}


export default __exports__